import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const OtherSportIcon = observer('OtherSportIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.9996 22C17.5224 22 21.9996 17.523 21.9996 12C21.9996 6.47705 17.5224 2 11.9996 2C6.47678 2 1.9996 6.47705 1.9996 12C1.9996 17.523 6.47678 22 11.9996 22ZM7.9996 13.5C8.82797 13.5 9.4996 12.8284 9.4996 12C9.4996 11.1716 8.82797 10.5 7.9996 10.5C7.17123 10.5 6.4996 11.1716 6.4996 12C6.4996 12.8284 7.17123 13.5 7.9996 13.5ZM13.4996 12C13.4996 12.8284 12.828 13.5 11.9996 13.5C11.1712 13.5 10.4996 12.8284 10.4996 12C10.4996 11.1716 11.1712 10.5 11.9996 10.5C12.828 10.5 13.4996 11.1716 13.4996 12ZM15.9996 13.5C16.828 13.5 17.4996 12.8284 17.4996 12C17.4996 11.1716 16.828 10.5 15.9996 10.5C15.1712 10.5 14.4996 11.1716 14.4996 12C14.4996 12.8284 15.1712 13.5 15.9996 13.5Z'
                fill='fill'
            />
        </SvgElement>
    );
});
